<template>
  <div
    class="popin-overlay"
    @click="closePopin"
  >
    <div
      class="popin-content"
      @click.stop
    >
      <button
        class="close-button"
        @click="closePopin"
      >
        <Close />
      </button>
      <transition
        name="fade-slide-up"
        appear
      >
        <component
          :is="product.box ? 'div':'Coin3D'"
          :global-position="true"
        >
          <div
            class="popin-content-image"
            :class="`coin-zoom-${product.id}`"
          />
        </component>
      </transition>
    </div>
  </div>
</template>

<script>
import Close from '@/assets/images/decors/icons/close.svg?inline';
import Coin3D from '@/components/utils/product/Coin3D.vue';

export default {
  name: 'Popin',
  components: {
    Close,
    Coin3D,
  },
  computed: {
    product() {
      return this.$store.getters.getProductById(this.$route.params.id);
    },
  },
  mounted() {
    const root = document.getElementsByTagName('body')[0];
    root.style.setProperty('overflow', 'hidden');
  },
  beforeDestroy() {
    const root = document.getElementsByTagName('body')[0];
    root.style.setProperty('overflow', 'auto');
  },
  methods: {
    closePopin() {
      this.$router.push({ name: 'home' });
    },

  },
};
</script>

<style lang="stylus" scoped>
.popin-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(31, 21, 71, 0.8)
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

// uncomment this block to limit coin to 100vh
// .popin-content {
//   &-image {
//     max-height: 100vh;
//     width: auto;
//     background-size: cover;
//   }
// }

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  appearance: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  background: $cl-yellow;
  border-radius: 0;
  padding: 20px;
  line-height: 0;

  svg {
    margin: 0;
    padding: 0;
  }
}
</style>
